;(function (angular, _, moment) {
  'use strict'

  angular
    .module('kilo.routes.invoice.show')
    .controller('ValidateInvoiceController', ValidateInvoiceController)

  ValidateInvoiceController.$inject = ['$uibModalInstance', 'objType', 'date']

  function ValidateInvoiceController ($uibModalInstance, objType, date) {
    const self = this

    self.$onInit = () => {
      _.extend(self, {
        // Attributes
        // Methods
      })
      init()
    }

    function init () {
      self.objType = objType
      self.date = moment(date).isBefore(moment(new Date()).startOf('d'))
      self.today = false
      if (self.objType === 'invoice' || self.objType === 'situation') {
        self.objLabel = 'la facture'
      } else if (objType === 'order') {
        self.objLabel = 'le chantier'
      } else {
        self.objLabel = "l'avoir"
      }
    }

    init()

    function accept () {
      self.objType === 'invoice' ? $uibModalInstance.close({ close: true, today: self.today }) : $uibModalInstance.close(true)
    }

    function refuse () {
      self.objType === 'invoice' ? $uibModalInstance.close({ close: false }) : $uibModalInstance.close(false)
    }

    function cancel () {
      $uibModalInstance.dismiss()
    }

    _.extend(self, {
      cancel: cancel,
      accept: accept,
      refuse: refuse
    })
  }
})(window.angular, window._, window.moment)
